import React, {Component} from 'react';
import {RadioGroup, Radio} from 'react-radio-group';
import '../assets/apps.css';
import '../assets/custom.css';
import Helpers from '../Shared/Helpers';
import REST from '../Shared/REST';
import {withRouter} from 'react-router-dom';
import {clearInterval, setInterval} from "timers";
import {Buttons, Buttons1, CountDownComponent, VideoComponent, YouTubeVideoComponent} from "./Common";
import {Modal, OverlayTrigger, Tab, Tabs, Tooltip} from "react-bootstrap";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import "../assets/students/WordMark.css";
import videoInstructionPN from "../assets/images/video_instructions.png";
import InstructionModals from "../Shared/InstructionModals";
import TRACKING from "../Shared/DataTrackingPoints";
import DialogBox from "../Shared/DialogBox";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";
import rotateInstruction from "../assets/images/rotate_device_fff_bg.png";
import videoInstructionFull from "../assets/images/videoInstructionFull.png";
import startButton from "../assets/images/startButton.png";
import whiteboard from "../assets/images/wordMark2/Whiteboard.png";
import Hedgehog from "../assets/images/wordMark2/Hedgehog.png";
import Pig from "../assets/images/wordMark2/Pig.png";
import RainbowSpinner from "../assets/images/wordMark2/Rainbow spinner.png";
import Wheel from "../assets/images/wordMark2/Wheel.png";
import SpinnerPickArrow from "../assets/images/wordMark2/Spinner pick_arrow.png";
import SpeechBubbleRight from "../assets/images/wordMark2/Speech bubble (right adjusted).png";
import YellowArrow from "../assets/images/wordMark2/Yellow arrow.png";
import YellowArrowRotate from "../assets/images/wordMark2/Yellow arrow rotate.png";
import YellowArrow2 from "../assets/images/wordMark2/Yellow arrow 2.png";
import SpeechBubbleLeft from "../assets/images/wordMark2/Speech bubble (left adjusted).png";
import Cow from "../assets/images/wordMark2/Cow.png";
import LineRight from "../assets/images/wordMark2/LineRight.png";
import LineLeft from "../assets/images/wordMark2/LineLeft.png";
import ico_x from "../assets/images/modal_x_red.png";



let seconds = 0;
let minutes = 0;
let secs = 0;
let resultTime = '';
let TaskTime=180;

const tooltipStartTyping = (
    <Tooltip id="tooltipStartTyping">
        Start Typing!
    </Tooltip>
);
class WordMark2Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            passages: [],
            loadedScores: false,
            bestScores:{
                wordmarkScore:1,
                wordmarkLevel:1
            }
        };
        this.handleActive = this.handleActive.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
    }

    handleActive = (active) => {
        this.setState({active: active});
    };

    handleSurveyBack(){
        this.props.history.goBack();
    }
    render() {
        return (
            <div className={this.state.active !==2 ? "bgGrey WordMarkContainer" : "bgYellow WordMarkContainer"}>
                {
                    this.state.active === -1 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark2</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        level={this.state.bestScores.wordmarkLevel}
                                                        step={this.state.bestScores.wordmarkScore}
                                                        steps={6}
                                                        maxLevel={12}
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                   this.state.active === 0  ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark2</h1>
                                        <div  style={{width:800,marginTop:10,marginLeft:100,textAlign: "center"}}>

                                            <div style={{fontSize:"20px",fontFamily: 'Neucha', letterSpacing:'4px', fontWeight:"bold"}}>You have 3 minutes to write a story.</div>
                                        </div>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <div  style={{width:80, marginLeft:'auto', marginRight:'auto',marginTop:150}}>
                                                    <img src={Cow} style={{width:80}}/>
                                                </div>
                                                <div className={"col-md-3"} style={{}}>
                                                    <img src={LineRight} style={{width:20, marginTop:-250, marginLeft:550}}/></div>
                                                <div className={"col-md-3"} style={{marginLeft:560, marginTop:-240}}>
                                                    <h4>Spin a wheel.<br/> Pick your ideas.<br/>Write a story ！</h4>
                                                </div>

                                            </div>
                                        </div>
                                        <div  style={{width:800,marginTop:10,marginLeft:100,textAlign: "center"}}>
                                            <div style={{fontSize:"20px",fontFamily: 'Neucha', letterSpacing:'4px', fontWeight:"bold"}}>Your story will be saved automatically after 3 minutes.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1  ?
                        <div>

                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"wordmark"} practice buttonClick={this.handleActive} currentTabActive={this.state.active} />
                                    <div className="appContainer wordmark">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>WordMark2: Show Me</h1>
                                        <div className={"row"} style={{marginLeft:'auto',marginRight:'auto',width:830}}>
                                            <div className={"col-xs-12 centerBlock"} >
                                                <YouTubeVideoComponent width={800} height={600} url={"https://www.youtube.com/embed/xpX8pIwkWmc?rel=0"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                            <Tutorial studentUser={this.props.studentUser} buttonClick={this.handleActive} passage={this.state.passages[0]} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                            <WordMarkContent studentUser={this.props.studentUser} handleSurveyBack={this.handleSurveyBack} buttonClick={this.handleActive} passages={this.state.passages}/>
                            <Buttons appName={"wordmark"} buttonClick = {this.handleActive} currentTabActive={this.state.active} noScore={true}/>
                        </div>
                        : null
                }

            </div>
        )
    }
}

class Tutorial extends Component {

    constructor(props) {
        super(props);
        this.state = {passage: this.props.passage};
    }

    render() {
        let passages = [];
        passages.push(this.props.passage);
        return (
            <WordMarkContent studentUser={this.props.studentUser} buttonClick={this.props.buttonClick} passages={passages} practice={true} />
        );
    }
}

class WordMarkContent extends Component {
    constructor(props) {
        super(props);
        this.random = this.random.bind(this);
        this.state = {
            popupSurvey: false,
            device: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
            orientation: !navigator.maxTouchPoints ? 'desktop' : navigator.platform.includes('Linux')?'ChromeBook': !(window.screen.orientation && window.screen.orientation.angle) ? 'portrait' : 'landscape',
            passages: this.props.passages,
            passage: this.props.passages[this.random()],
            hint: `Read the story starter above. \nIf you like it click 'Begin'.\nIf you do not like it click 'Change'\nYou have one minute to think about your story.\nYou will have three minutes to type your story.`,
            started: false,
            story: '',
            time: 60,
            thinkTime: 60,
            finished: false,
            sessionTime: 60,
            modalInstruction:false,
            showNotice:false,
            chosenWord1:'',
            chosenWord1Id: -1,
            chosenWord2:'',
            chosenWord2Id: -1,
            startNowClicked:false,
            practiceFinished:false

        };
        this.timer = 0;
        this.thinkTimer = 0;
        this.hideInstruction = this.hideInstruction.bind(this);
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.handleChangeStory = this.handleChangeStory.bind(this);
        this.handleBegin = this.handleBegin.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleToggleInstruction = this.handleToggleInstruction.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.updateChosenWords = this.updateChosenWords.bind(this);

        this.thinkCountDown = this.thinkCountDown.bind(this);
        this.startThinkTimer = this.startThinkTimer.bind(this);
        this.handleStartNow= this.handleStartNow.bind(this);



    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }

    async componentDidMount() {
        window.addEventListener("resize", this.detect);
        window.addEventListener("beforeunload", this.onUnload);
        await this.setState({
            modalInstruction: true
        });

        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_WM_START,
                metadata: {}
            }
        })
        this.handleAnalytics();
    }

    detect = async () => {

        await this.setState({
            device: !!navigator.maxTouchPoints ? 'mobile' : 'computer',
            orientation: !navigator.maxTouchPoints ? 'desktop' : navigator.platform.includes('Linux')?'ChromeBook': !window.screen.orientation.angle ? 'portrait' : 'landscape'
        });
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleToggleInstruction= (toggleInstruction) => {
        localStorage.setItem('WordmarkInstruction', toggleInstruction);
    }

    startTimer() {
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        seconds = this.state.time - 1;
        minutes = parseInt(seconds / 60, 10);
        secs = parseInt(seconds % 60, 10);
        if(minutes > 0){
            if(minutes === 2 && secs === 59){
                resultTime = '3 minutes left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(minutes === 1 && secs === 59){
                resultTime = '2 minutes left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
        }
        else {
            if(minutes === 0 && secs === 59){
                resultTime = '1 minute left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(secs === 30){
                resultTime = '30 seconds left';
                if(resultTime !== '') {
                    setTimeout(
                        function() {
                            resultTime = '';
                        }
                            .bind(this), 5000);
                }
            }
            if(secs <= 15){
                resultTime = secs + ' seconds left'
            }
        }
        this.setState({time: seconds});
        if (seconds === 0) {
            if (!this.state.started) {
                this.setState({time: TaskTime, sessionTime: TaskTime, started: true, modalInstruction:false});
            } else if(!this.props.practice){
                clearInterval(this.timer);
                this.handleSave();
            }
            else if(this.props.practice){
                clearInterval(this.timer);
                this.setState({practiceFinished: true});
            }
        }

    }

    startThinkTimer() {
        this.thinkTimer = setInterval(this.thinkCountDown, 1000);
    }

    thinkCountDown() {
        seconds = this.state.thinkTime - 1;
        minutes = parseInt(seconds / 60, 10);
        secs = parseInt(seconds % 60, 10);
        this.setState({thinkTime: seconds});
        if (seconds === 0) {
            this.setState({time: TaskTime, sessionTime: TaskTime, started: true, modalInstruction:false});
            clearInterval(this.thinkTimer);
            this.startTimer();
        }
    }
    handleStartNow(){
        this.setState({time: TaskTime, sessionTime: TaskTime, started: true, modalInstruction:false});
        clearInterval(this.thinkTimer);
        this.startTimer();
    }

    random() {
        const min = 1;
        let max = this.props.passages.length;
        return Math.floor((min + Math.random() * (max - min)) - 1);
    }

    handleTextChange(e) {
        this.setState({story: e.target.value}, () => {
            console.log(this.state.story);
        });
    }

    handleChangeStory(e) {
        this.setState({passage: this.state.passages[this.random()], time: 60}, () => {
            this.setState({story: this.state.passage.storyStarter.replace('...', '')});
        });
    }

    handleBegin(e) {
        this.setState({started: true, time: TaskTime, sessionTime: TaskTime});
    }

    handleSave(e) {
        this.setState({started: false, finished: true});
        if(!this.props.practice) {
            window.removeEventListener("beforeunload", this.onUnload);
            this.saveStory();
        }
        if(this.props.practice){
           this.props.buttonClick(0);
        }
        // e.preventDefault();
    }

    saveStory() {
        let body = {
            storyPrompt1 : this.state.chosenWord1,
            storyPrompt1Id : this.state.chosenWord1Id,
            storyPrompt2 : this.state.chosenWord2,
            storyPrompt2Id : this.state.chosenWord2Id,
            studentResponse: this.state.story,
            guid: ""
        };
        REST.postWordMark2Session(body).then((response) => {
            console.log('Response', response);
        }, (error) => {
            console.log('Response Error', error);
        });
    }
    handleShowNotice(){
        this.setState({showNotice: true});
    }
    handleClose(e) {
        this.setState({finished: false, popupSurvey: true});
    }
    hideInstruction(){
        console.log('timeout003');
        this.setState({modalInstruction: false});
        this.startThinkTimer();
    }
    updateChosenWords(chosenWord1, chosenWord1Id, chosenWord2, chosenWord2Id){
        console.log('updateChosenWords');
        this.setState({chosenWord1: chosenWord1, chosenWord1Id: chosenWord1Id, chosenWord2:chosenWord2, chosenWord2Id: chosenWord2Id});
    }
    async handleSurveyBack(){
        this.props.handleSurveyBack();
    }


    prepareHint() {
        let {time, hint} = this.state;
        let regex = /\n/g;
        let h = hint.split(regex);
        let t = '';
        if (time <= 60 && time >= 57) {
            t = h[0];
        } else if (time < 57 && time >= 54) {
            t = t.concat(h[0]).concat('\n').concat(h[1]);
        } else if (time < 54 && time >= 51) {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]);
        } else if (time < 51 && time >= 48) {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]);
        } else {
            t = t.concat(h[0]).concat('\n').concat(h[1]).concat('\n').concat(h[2]).concat('\n').concat(h[3]).concat('\n').concat(h[4]);
        }
        return t;
    }

    render() {
        let hint = this.prepareHint();
        let response = '';
        if (this.state.passage && this.state.passage.storyStarter && this.state.story.length <= this.state.passage.storyStarter.length) {
            response = 'There is nothing to score';
        }
        else {
            response = 'Your story was sent to your teacher';
        }

        return (
            <div >

                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"} >
                    {/*<DialogBox notificationModal modalOpen={this.state.orientation == 'portrait'} sectionContent={'Please use landscape mode.'} noClose />*/}
                    <DialogBox surveyModal app={'WordMark'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>

                    <div className="container" >
                        <WordMark2Modal
                            modalOpen={this.state.modalInstruction}
                            instructionMask={videoInstructionPN}
                            toggleInstruction={this.handleToggleInstruction}
                            time={this.state.time}
                            sessionTime={this.state.sessionTime}
                            buttonClick={this.props.buttonClick}
                            changeClick={(active)=>{this.handleChangeStory(); console.log('Change Story!')}}
                            hideInstruction = {this.hideInstruction}
                            updateChosenWords = {this.updateChosenWords}
                        />
                        {this.state.started ?
                        <div className={"row"} style={{}}>
                            <div>
                                <div style={{fontStyle:"bold",fontSize:"30px",textAlign:"center"}}>Write a Story With</div>
                                <div style={{fontStyle:"normal",fontSize:"30px",textTransform: 'uppercase',textAlign:"center"}}>"{this.state.chosenWord1}" And "{this.state.chosenWord2}"</div>
                            </div>

                        </div>:null}
                        <div className="row">
                            <div className="passage tc">
                                {this.state.started ?

                                    <OverlayTrigger placement="top" overlay={tooltipStartTyping}>
                                    <textarea ref={(input) => input && input.focus()}  style={{marginTop:50}} className={"wordmark1"} spellCheck={false} value={this.state.story} onChange={this.handleTextChange}/>
                                    </OverlayTrigger>
                                    :

                                    <div style={{marginLeft:400, marginTop:200}}>
                                        <div  style={{marginLeft:-200,marginTop:-100,width:800}}>
                                            <div style={{fontStyle:"normal",fontSize:"40px"}}>You have 3 Minutes to Write a Story With</div>
                                            <div className="row">
                                                <div style={{fontStyle:"normal",fontSize:"30",textTransform: 'uppercase'}}>"{this.state.chosenWord1}" And "{this.state.chosenWord2}"</div>
                                            </div>
                                        </div>
                                        <div style={{marginLeft:-400,marginTop:-50}}>
                                            <img src={Hedgehog} style={{width:150,marginTop:200}}/>
                                            <div className="row" style={{ marginTop:20}}>
                                                <div style={{marginLeft:400,marginTop:10,width:300}}>
                                                    <div style={{fontStyle:"normal",fontSize:28}}>ONE MINUTE TO THINK</div>
                                                </div >
                                                <div style={{marginLeft:500, marginTop:-80}}>
                                                    <div style={{marginLeft:-250}}>
                                                        <div  style={{display:'inline-block'}}><CountDownComponent time={this.state.thinkTime} sessionTime={this.state.sessionTime}/></div>
                                                        <div style={{fontStyle:"normal",fontSize:28,marginLeft:120, marginTop:-90}}>Or</div>
                                                    </div>

                                                </div>

                                                <div className={"col-sm-1"} style={{ marginTop:-60,marginLeft:780}}>
                                                    <a onClick={this.handleStartNow} className="handBtn active" style={{width:150, fontSize:20}}>
                                                        <span>Start Now</span>
                                                    </a>
                                                </div>

                                            </div>
                                        </div>

                                    </div>}
                            </div>
                        </div>



                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="divBottomRelative tc">
                                <div className={"row tc"}>
                                    <div className={"col-md-4"}></div>
                                    <div className={"col-md-4"}>
                                        {this.state.started ?
                                            <a onClick={this.handleSave} className="handBtn hidden">
                                                <span>Save</span>
                                            </a>
                                            :
                                            null
                                        }
                                    </div>
                                    <div className={"col-md-4"}>
                                        <div className={"row pull-right"}>
                                            {
                                                this.state.started ?
                                                <div>
                                                    <div style={{display:'inline-block',position:'relative',fontFamily:'mainFont',fontStyle:'sans-serif',fontSize:'1.5em',top:-60}}>{resultTime}</div>
                                                    <div className={resultTime ==='' ? "hidden": ""} style={{display:'inline-block'}}><CountDownComponent time={this.state.time} sessionTime={this.state.sessionTime}/></div>
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal id={"resultBox"} show={this.state.finished && !this.props.practice}>
                    <div className="modal-content">
                        <div className={"row modal-body"} >
                            {/*<span style={{cursor: "pointer"}} onClick={this.closeModal}><img*/}
                            {/*style={{width: 50, marginTop: 25, float: 'right'}} src={closeModalIcon}/></span>*/}
                            <div className="section">
                                <h1 style={{marginBottom:25,fontSize:35}}>Finished</h1>
                                <p>{response}</p>
                                <a className="handBtn" style={{marginTop:15}} onClick={this.handleClose}>
                                    <span>Close</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal id={"resultBox"} show={this.state.practiceFinished && this.props.practice}>
                    <div className="modal-content">
                        <div className={"row modal-body"} >
                            {/*<span style={{cursor: "pointer"}} onClick={this.closeModal}><img*/}
                            {/*style={{width: 50, marginTop: 25, float: 'right'}} src={closeModalIcon}/></span>*/}
                            <div className="section">
                                <h1 style={{marginBottom:25,fontSize:35}}>Finished</h1>
                                <div style={{marginBottom:25,fontSize:25}}>This will not be sent to your teacher.</div>
                                <a className="handBtn" style={{marginTop:15}} onClick={this.handleSave}>
                                    <span>Close</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const WordMark2Modal = class DialogBoxComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: this.props.modalOpen ? this.props.modalOpen : false
        }

        this.closeModal = this.closeModal.bind(this);
        this.instructionToggle = this.instructionToggle.bind(this);
        this.hideInstruction = this.hideInstruction.bind(this);
    }

    componentDidMount() {
    }

    openModal() {
        this.setState({ isModalOpen: true });
    }

    instructionToggle(event){
        this.props.toggleInstruction(event.target.checked);
    }

    closeModal(){
        this.props.closeClick(false);
        this.setState({ isModalOpen: false });
    }
    hideInstruction(){
        console.log('timeout002');
        this.props.hideInstruction();
    }

    render() {

        return (
            <Modal id="WordMark2Box" show={this.props.modalOpen} >

                    <div className="modal-content" >

                        <div style={{width:1200, height:1000, maxHeight:"100%", marginLeft:"auto", marginRight:"auto", marginTop:0}}>
                        <div className={"row modal-body"} >
                            <div className="section">
                                <Wordmark2Instruction
                                    buttonClick={this.props.buttonClick}
                                    hideInstruction={this.hideInstruction}
                                    updateChosenWords={this.props. updateChosenWords}
                                    beginClick={this.props.beginClick}
                                    changeClick={this.props.changeClick}
                                    time={this.props.time}
                                    sessionTime={this.props.sessionTime}
                                    starterTitle={this.props.starterTitle}
                                    instructionMask={videoInstructionFull}
                                    startButton={startButton} />

                                <div className={"col-md-12"}>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        )
    }
};

class Wordmark2Instruction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key:1,
            wordList: ['','','','','',''],
            wordIdList: [-1,-1,-1,-1,-1,-1],
            word1: '',
            word2: '',
            word3: '',
            word4: '',
            word5: '',
            word6: '',
            chosenWord1: '',
            chosenWord1Id: -1,
            chosenWord2: '',
            chosenWord2Id: -1,
            arrowShowed:'',
            timer: null,
            timer1: null,
            timer2: null,
            time: 5000,
            previousSpinNumber1: 0,
            previousSpinNumber2: 0,
            spinStyle1:{width: 220, cursor:'pointer'},
            spinStyle2:{width: 220, cursor:'pointer'},
            spinning2:false,
            checkAllow1: false,
            checkAllow2: false,
            progress: 'start0',
            selectedValue1:'',
            selectedValue2:'',
            bothWordChosen:false,

        }

        this.handleSelect = this.handleSelect.bind(this);
        this.beginStory = this.beginStory.bind(this);
        this.changeStory = this.changeStory.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.shuffleWords = this.shuffleWords.bind(this);
        this.handleRainbowSpin1 = this.handleRainbowSpin1.bind(this);
        this.handleRainbowSpin2 = this.handleRainbowSpin2.bind(this);
        this.handleWordChecked1 = this.handleWordChecked1.bind(this);
        this.handleWordChecked2 = this.handleWordChecked2.bind(this);
        this.handleStartWriting= this.handleStartWriting.bind(this);

    }

    async componentDidMount() {
        await REST.getWordMark2Random1().then(async(response) => {
            if (response.success) {
                let wordList = [];
                let wordIdList = [];
                wordList[0]=response.body[0].storyStarter;
                wordList[1]=response.body[1].storyStarter;
                wordList[2]=response.body[2].storyStarter;
                wordIdList[0]=response.body[0].id;
                wordIdList[1]=response.body[1].id;
                wordIdList[2]=response.body[2].id;
                await this.setState({wordList: wordList, wordIdList:wordIdList});
            } else {
                console.log('WordMark Error', response);
            }
        }, (error) => {
            console.log('WordMark Error', error);
        });
        await REST.getWordMark2Random2().then(async(response) => {
            if (response.success) {
                let wordList = [];
                let wordIdList = [];
                wordList[0]=this.state.wordList[0];
                wordList[1]=this.state.wordList[1];
                wordList[2]=this.state.wordList[2];
                wordList[3]=response.body[0].storyStarter;
                wordList[4]=response.body[1].storyStarter;
                wordList[5]=response.body[2].storyStarter;
                wordIdList[0]=this.state.wordIdList[0];
                wordIdList[1]=this.state.wordIdList[1];
                wordIdList[2]=this.state.wordIdList[2];
                wordIdList[3]=response.body[0].id;
                wordIdList[4]=response.body[1].id;
                wordIdList[5]=response.body[2].id;
                await this.setState({wordList: wordList, wordIdList:wordIdList});
            } else {
                console.log('WordMark Error', response);
            }
        }, (error) => {
            console.log('WordMark Error', error);
        });


       // this.shuffleWords();
    }

    handleSelect(key){
        this.setState({key: key});
    }
    beginStory(){
        this.props.beginClick(true);
    }
    changeStory(){
        this.props.changeClick(true);
    }
    handleBack(){
        this.props.buttonClick(0);
    }

    shuffleWords(){
        var currentIndex = this.state.wordList.length,  randomIndex;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [this.state.wordList[currentIndex], this.state.wordList[randomIndex]] = [
                this.state.wordList[randomIndex], this.state.wordList[currentIndex]];
        }

    }

    async handleWordChecked1(wordNo){
        console.log("chosen001-0");
        console.log(this.state.progress);
        if (this.state.progress == 'spinWord6'||this.state.progress == 'choseWord1'||this.state.progress == 'choseWord2') {
            console.log("chosen001-1");
            console.log(this.state.arrowShowed);
            if(this.state.arrowShowed == '') {
                console.log("chosen001-2");

                await this.setState({
                    chosenWord1: this.state.wordList[wordNo],
                    chosenWord1Id: this.state.wordIdList[wordNo],
                    progress: 'choseWord1',
                    checkAllow2: true,
                    selectedValue1: wordNo+""
                });
            }
            if(this.state.arrowShowed == '1'){
                console.log("chosen001-3");
                console.log(this.state.selectedValue1);
                await this.setState({ chosenWord1: this.state.wordList[wordNo],
                    chosenWord1Id: this.state.wordIdList[wordNo],
                    progress: 'choseWord2',
                    checkAllow2: true,
                    selectedValue1: wordNo+""});
                console.log(this.state.selectedValue1);
            }
        }

    }

    async handleWordChecked2(wordNo){
        if(this.state.checkAllow2) {
            if (this.state.progress == 'choseWord1' || this.state.progress == 'choseWord2') {
                await this.setState({
                    chosenWord2: this.state.wordList[wordNo],
                    chosenWord2Id: this.state.wordIdList[wordNo],
                    progress: 'choseWord2',
                    selectedValue2: wordNo + ""
                });

            }
        }

        if (this.state.arrowShowed == ''&&this.state.checkAllow2) {
            await this.setState({arrowShowed:'1'});
        }
        if(this.state.checkAllow2==true&&this.state.progress == 'choseWord2'){
            await this.setState({bothWordChosen:true});
        }
    }
    async handleStartWriting(){
        if (this.state.progress == 'choseWord2'||this.state.progress == 'choseWord1') {
            this.props.updateChosenWords(this.state.chosenWord1,this.state.chosenWord1Id,this.state.chosenWord2,this.state.chosenWord2Id);
            this.props.hideInstruction();
        }
    }

    async handleRainbowSpin1() {
        if(this.state.wordList[0]) {
            let randomNum = Number((Math.random() * 8 + 4).toFixed());

            let timer1 = setInterval(async () => {
                if (this.state.progress == 'start0') {
                    await this.setState({progress: 'spinWord1', word1: this.state.wordList[0]});
                } else if (this.state.progress == 'spinWord1') {
                    await this.setState({progress: 'spinWord2', word2: this.state.wordList[1]});
                } else if (this.state.progress == 'spinWord2') {
                    await this.setState({progress: 'spinWord3', word3: this.state.wordList[2]});
                } else if (this.state.progress == 'spinWord3') {
                    this.setState({progress: 'spinWord4', word4: this.state.wordList[3]});
                } else if (this.state.progress == 'spinWord4') {
                    this.setState({progress: 'spinWord5', word5: this.state.wordList[4]});
                } else if (this.state.progress == 'spinWord5') {
                    this.setState({progress: 'spinWord6', checkAllow1: true, word6: this.state.wordList[5]});
                }
                clearInterval(timer1);
            }, this.state.previousSpinNumber1 == 0 ? randomNum * 83 : ((12 - this.state.previousSpinNumber1) + randomNum) * 83)


            if (this.state.previousSpinNumber1 > 0) {
                await this.setState({
                    spinStyle1: {
                        cursor: 'pointer',
                        width: 220,
                        animation: 'backSpin' + this.state.previousSpinNumber1 + ' ' + (1 - this.state.previousSpinNumber1 / 12) + 's linear 1', // 'spin'+ randomNum + ` 3s linear 1`
                    }
                });
            }
            let timer = setInterval(async () => {
                await this.setState({
                    spinStyle1: {
                        cursor: 'pointer',
                        width: 220,
                        transform: 'rotate(0deg)'
                    }
                });


                await this.setState({
                    previousSpinNumber1: randomNum,
                    spinStyle1: {
                        cursor: 'pointer',
                        width: 220,
                        animation: 'spin' + randomNum + ' ' + randomNum / 12 + 's linear 1', // 'spin'+ randomNum + ` 3s linear 1`
                        transform: 'rotate(' + (randomNum * 30) + 'deg)'
                    }
                });
                clearInterval(timer);
            }, this.state.previousSpinNumber1 == 0 ? 1 : (12 - this.state.previousSpinNumber1) * 83);
        }
    }

    async handleRainbowSpin2(){

        let randomNum = Number((Math.random() * 8 + 4).toFixed());
        let timer1 = setInterval(async()=> {
        if(this.state.progress == 'spinWord3') {
            this.setState({progress: 'spinWord4', word4:this.state.wordList[3]});
        }else if(this.state.progress == 'spinWord4'){
            this.setState({progress: 'spinWord5', word5:this.state.wordList[4]});
        }
        else if(this.state.progress == 'spinWord5'){
            this.setState({progress: 'spinWord6', checkAllow1:true, word6:this.state.wordList[5]});
        }
            clearInterval(timer1);
        },this.state.previousSpinNumber2==0? randomNum*83 : ((12-this.state.previousSpinNumber2)+randomNum)*83)

        if(this.state.previousSpinNumber2 > 0){
            await this.setState({
                spinStyle2: {
                    width:220,
                    animation:  'backSpin' + this.state.previousSpinNumber2 +' '+ (1-this.state.previousSpinNumber2/12) +'s linear 1',
                }
            });
        }
        let timer = setInterval(async()=> {
            await this.setState({
                spinStyle2: {
                    width: 220,
                    transform: 'rotate(0deg)'
                }
            });


            await this.setState({
                previousSpinNumber2: randomNum,
                spinStyle2: {
                    width: 220,
                    animation: 'spin' + randomNum + ' ' + randomNum / 12 + 's linear 1', // 'spin'+ randomNum + ` 3s linear 1`
                    transform: 'rotate(' + (randomNum * 30) + 'deg)'
                }
            });
            clearInterval(timer);
        },this.state.previousSpinNumber2==0?1:(12-this.state.previousSpinNumber2)*83);
    }

    render() {
        return (

            <div className={"col-md-12"} style={{textAlign:'center',marginTop:30}}>
                <Buttons1 appName={"wordmark"} buttonClick = {this.handleBack}  noScore={true}/>
                <div style={{marginTop:-100}}>
                <h2>WordMark2</h2>
                </div>
                <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="wordmarkTab">
                    <Tab eventKey={1} >
                            <div>
                                <div className={"row"} style={{marginTop:10}}>


                                    <div className={"col-sm-6"}  style={{marginTop:20}}>
                                        <div className={"wordMarkWhiteBoard"} style={{marginTop:-150}}>
                                            <h3>IDEA 1</h3>
                                        </div>
                                        <div >
                                            <RadioGroup
                                                name="radio-group1"
                                                selectedValue={this.state.selectedValue1}
                                                onChange={this.handleWordChecked1}>
                                                <div style={{marginLeft:80,marginTop:-140, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="0"  />
                                                    </label>
                                                </div >
                                                <div style={{marginLeft:80,marginTop:20, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="1"  />
                                                    </label>
                                                </div >
                                                <div style={{marginLeft:80,marginTop:20, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="2" />
                                                    </label>
                                                </div >
                                            </RadioGroup>
                                        </div>
                                        <div className={"row"} style={{marginTop:-130,textAlign:"left",marginLeft:115,width:360}}>

                                            <div style={{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked1(0)}}>
                                                {this.state.word1? this.state.word1.toLowerCase(): ''}<br/>
                                            </div>
                                            <div style={{marginTop:8,marginLeft:0,zIndex:1,userSelect: "none"}} > _______________________________________________________</div>
                                        </div>
                                        <div className={"row"} style={{marginTop:20,textAlign:"left",marginLeft:115,width:360}}>
                                            <div style={{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked1(1)}}>
                                                {this.state.word2? this.state.word2.toLowerCase() : ''}<br/>
                                            </div>
                                            <div style={{marginTop:8,marginLeft:0,zIndex:1,userSelect: "none"}} > _______________________________________________________</div>
                                        </div>
                                        <div className={"row"} style={{marginTop:20,textAlign:"left",marginLeft:115,width:360}}>
                                            <div style={{marginLeft:20,fontWeight:"bold",cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked1(2)}}>
                                                {this.state.word3? this.state.word3.toLowerCase() : ''}<br/>
                                            </div>
                                            <div style={{marginTop:8,marginLeft:0,zIndex:1,userSelect: "none"}}> _______________________________________________________</div>
                                        </div>
                                    </div>

                                    <div className={"col-sm-6"} style={{marginTop:-185,marginLeft:575}}>
                                        <div className={"wordMarkWhiteBoard"} style={{marginTop:10}}>
                                            <h3>IDEA 2</h3>
                                        </div>
                                        <div>
                                            <RadioGroup
                                                name="radio-group2"
                                                selectedValue={this.state.selectedValue2}
                                                onChange={this.handleWordChecked2}
                                                >
                                                <div style={{marginLeft:80,marginTop:-140, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="3" />
                                                    </label>
                                                </div>
                                                <div style={{marginLeft:80,marginTop:20, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="4"  />
                                                    </label>
                                                </div>
                                                <div style={{marginLeft:80,marginTop:20, cursor:"pointer",width:20}}>
                                                    <label >
                                                        <Radio value="5" />
                                                    </label>
                                                </div>
                                            </RadioGroup>
                                        </div>
                                        <div className={"row"} style={{marginTop:-130,textAlign:"left",marginLeft:115,width:360}}>
                                            <div style={{marginLeft:20,fontWeight:"bold", cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked2(3)}}>
                                                {this.state.word4? this.state.word4.toLowerCase() : ''}<br/>
                                            </div>
                                            <div style={{marginLeft:0,marginTop:8,zIndex:1,userSelect: "none"}} > _______________________________________________________</div>
                                        </div>
                                        <div className={"row"} style={{marginTop:20,textAlign:"left",marginLeft:115,width:360}}>
                                            <div style={{marginLeft:20,fontWeight:"bold", cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked2(4)}}>
                                                {this.state.word5? this.state.word5.toLowerCase() : ''}<br/>
                                            </div>
                                            <div style={{marginTop:8,marginLeft:0,zIndex:1,userSelect: "none"}} > _______________________________________________________</div>
                                        </div>
                                        <div className={"row"} style={{marginTop:20,textAlign:"left",marginLeft:115,width:360}}>
                                            <div style={{marginLeft:20,fontWeight:"bold", cursor:"pointer",zIndex:11,userSelect: "none",display: "inline-block",position:'absolute'}} onClick={()=>{this.handleWordChecked2(5)}}>
                                                {this.state.word6? this.state.word6.toLowerCase() : ''}<br/>
                                            </div>
                                            <div style={{marginTop:8,marginLeft:0,zIndex:1,userSelect: "none"}} > _______________________________________________________</div>
                                        </div>
                                    </div>

                                </div>
                                <div className={"row"}  >
                                    <div className={"col-sm-6"} style={{marginLeft:300, zIndex:11, marginRight:'auto',marginTop:80, visibility:this.state.progress !=='choseWord2'?"visible":"hidden"}}>
                                        <img src={Wheel} style={this.state.spinStyle1} onClick={this.handleRainbowSpin1}/>
                                    </div>

                                </div>
                                <div className={"row"} >
                                    <div className={"col-sm-6"} style={{marginLeft:300, zIndex:12, marginRight:'auto',marginTop:-230,visibility:this.state.progress !=='choseWord2'?"visible":"hidden"}}>
                                        <img src={SpinnerPickArrow} style={{width:80,cursor:'pointer'}} onClick={this.handleRainbowSpin1}/>
                                    </div>

                                </div>
                                <div className={"row"}>
                                    <div className={"col-sm-3"} >
                                    </div>
                                    <div className={"col-sm-3"} style={{marginLeft:-110, marginTop:-140}}>
                                        <img src={Hedgehog} style={{width:150}}/>
                                    </div>
                                    <div className={"col-sm-3"} style={{marginLeft:240, marginTop:-150}}>
                                        <img src={Pig} style={{width:120}}/>
                                    </div>
                                </div>
                                <div className={"row"} style={{width:1200}}>
                                    <div>
                                        {this.state.progress ==='start0'? <div className={"col-sm-1"} style={{marginLeft:400, marginTop:-240}}>
                                        <img src={YellowArrowRotate} style={{width:60}}/></div>:null}
                                    </div>
                                    <div>
                                        {this.state.progress ==='spinWord6'? <div className={"col-sm-1"} style={{marginLeft:320, marginTop:-300,rotate:'345deg'}}>
                                            <img src={YellowArrow2} style={{width:100}}/></div>:null}
                                    </div>

                                    <div>
                                        {this.state.progress ==='spinWord3'? <div className={"col-sm-1"} style={{marginLeft:700, marginTop:-240}}>
                                        <img src={YellowArrow} style={{width:60}}/>
                                        </div>:null}
                                    </div>
                                    <div>
                                        {this.state.progress== 'choseWord1'? <div className={"col-sm-1"} style={{marginLeft:700, marginTop:-300,rotate:'0deg'}}>
                                            <img src={YellowArrow2} style={{width:100}}/>
                                        </div>:null}
                                    </div>
                                    <div>
                                        {this.state.progress ==='start0'|| this.state.progress ==='spinWord1'
                                        || this.state.progress ==='spinWord2'|| this.state.progress ==='spinWord6' ? <div className={"col-sm-3"} style={{marginLeft:50, marginTop:-210}}>
                                            <img src={LineLeft} style={{width:30, marginTop:40}}/></div>:null}
                                    </div>
                                    <div className={"col-sm-3"} style={{marginLeft:5, marginTop:-240}}>
                                        <h3>
                                            <div style={{width:170,marginLeft:75}}>
                                                {this.state.progress == 'start0'?'Spin my wheel 3 times！':null}
                                                {this.state.progress == 'spinWord1'?'You have 2  more spins！':null}
                                                {this.state.progress == 'spinWord2'?'You have 1 more spin！':null}
                                                {this.state.progress == 'spinWord6'?'Chose one idea！':null}

                                            </div>
                                        </h3>
                                    </div>
                                    <div>
                                        {this.state.progress ==='spinWord3'|| this.state.progress ==='spinWord4'
                                        || this.state.progress ==='spinWord5'|| this.state.progress ==='choseWord1'? <div className={"col-sm-3"} style={{marginLeft:800, marginTop:-210}}>
                                            <img src={LineRight} style={{width:30, marginTop:40}}/></div>:null}
                                    </div>
                                    <div className={"col-sm-3"} style={{marginLeft:890, marginTop:-225}}>
                                        <h3>
                                            <div style={{width:170,marginLeft:47}}>
                                                {this.state.progress == 'spinWord3'?'Spin my wheel 3 times！':null}
                                                {this.state.progress == 'spinWord4'?'You have 2 more spins！':null}
                                                {this.state.progress == 'spinWord5'?'You have 1 more spin！':null}
                                                {this.state.progress == 'choseWord1'?'Chose one idea！':null}

                                            </div>
                                        </h3>
                                    </div>
                                    <div className={"col-sm-3"} style={{width:200,marginLeft:490, marginTop:-200}}>
                                        <h3>
                                            {this.state.bothWordChosen?'Write a story using your ideas！':null}
                                        </h3>

                                        <div style={{ marginTop:30}}>
                                            {this.state.bothWordChosen ?
                                                <a onClick={this.handleStartWriting} className="handBtn">
                                                    <span>Start</span>
                                                </a>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>

                    </Tab>
                </Tabs>
            </div>
        )
    }
}


const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(WordMark2Component));





// WEBPACK FOOTER //
// ./src/StudentsComponent/WordMark2.js